export default __webpack_public_path__ + "static/media/other.749cab5d.svg";